var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7204 12.4217C14.7204 13.9269 13.5041 15.1433 11.9989 15.1433C10.4937 15.1433 9.27734 13.9269 9.27734 12.4217C9.27734 10.9165 10.4937 9.7002 11.9989 9.7002C13.5041 9.7002 14.7204 10.9165 14.7204 12.4217Z",
    stroke: "#758295",
    strokeWidth: 1.14031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9982 18.7089C14.6817 18.7089 17.1828 17.1276 18.9237 14.3909C19.6079 13.319 19.6079 11.5173 18.9237 10.4454C17.1828 7.70867 14.6817 6.12744 11.9982 6.12744C9.31466 6.12744 6.81358 7.70867 5.07271 10.4454C4.38852 11.5173 4.38852 13.319 5.07271 14.3909C6.81358 17.1276 9.31466 18.7089 11.9982 18.7089Z",
    stroke: "#758295",
    strokeWidth: 1.14031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.7171153ad98a4a238e704362a0c89103.svg";
export { ForwardRef as ReactComponent };